import { css } from '@emotion/react';
import dynamic from 'next/dynamic';

import { AppStore } from 'stores/AppStore';

import { colors } from 'styles/theme';
import { tabletUp, mobileOnly } from 'styles/utils';

import Container from 'components/shared/Container/Container';

import BrandLogo from '../BrandLogo/BrandLogo';
import Link from '../Link/Link';

import FooterLinks from './FooterLinks';

const DynamicCopyrights = dynamic(
  () =>
    import(
      /* webpackChunkName: "DynamicCopyrights" */
      './Copyrights'
    ),
  { ssr: false }
);

const footerCss = css`
  position: relative;
  z-index: 10;
`;

const menuCss = css`
  background-color: #212340;
  color: ${colors.white};
  padding: 50px 15px;
`;

const footerContainerCss = css`
  ${tabletUp} {
    display: flex;
  }
`;

const footerLogoSectionCss = css`
  ${tabletUp} {
    flex: 0.6;
  }

  ${mobileOnly} {
    margin-bottom: 36px;
  }
`;

function Footer() {
  return (
    <footer css={footerCss}>
      <div css={menuCss}>
        <Container css={footerContainerCss}>
          <div css={footerLogoSectionCss}>
            <Link href="/" aria-label={`${process.env.BRAND_NAME} logo`}>
              <BrandLogo
                color={colors.white}
                width={AppStore.isDipUti ? 126 : 140}
                height={38}
              />
            </Link>
          </div>
          <FooterLinks />
        </Container>
      </div>
      <DynamicCopyrights />
    </footer>
  );
}

export default Footer;
